import React from 'react';
import { Translate } from 'react-redux-i18n';
import { Divider, Fixed, Modal, Text } from 'rebass';
import { PvButton, PvButtonOutline } from 'styles/CustomComponents';

const ConfirmationModal = ({confirmText, confirmAction, hideModal}) => {
  const confirmClick = () => {
    confirmAction();
    hideModal();
  };

  return (
    <React.Fragment>
      <Fixed
        onClick={() => hideModal()}
        top={0}
        right={0}
        bottom={0}
        left={0}
      />
      <Modal width={['90%', '80%', '50vw']}>
        <Text p={[3, 3, 4]} textAlign='center'>
          <div>{confirmText}</div>
        </Text>
        <Divider
          my={2}
          w={1}
          borderBottom={2}
          borderColor='grays.1'
        />
        <Text py={2} textAlign='center'>
          <PvButton
            width='7em'
            onClick={confirmClick}>
            OK
          </PvButton>
          <PvButtonOutline
            width='7em'
            ml={2}
            onClick={() => hideModal()}>
            <Translate value='app.cancel' />
          </PvButtonOutline>
        </Text>
      </Modal>
    </React.Fragment>
  );
};

export default ConfirmationModal;


// WEBPACK FOOTER //
// ./src/components/modal/ConfirmationModal.jsx